import styled from "styled-components";

export const Div = styled.div`
	.brochure-pdf {
		width: 100%;
	}
	.outerCon {
	}
	.outerCon {
		overflow: hidden;
		height: 500px;
		width: 600px;
	}

	.outerCon iframe {
		width: inherit;
		height: inherit;
		overflow-x: hidden;
		overflow-y: auto;
	}
	.outerCon embed::-webkit-scrollbar {
		display: none;
	}
	embed::-webkit-scrollbar {
		display: none;
	}
	.view-pdf-btn {
		margin: 0 auto;
	}
	.description .react-pdf__Page__canvas {
		width: 100% !important;
	}
	.description canvas {
		width: 100% !important;
	}
`;
